export default __webpack_public_path__ + "static/media/bimb-color.6bed037e.svg";